import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import '../../css/immocom.css';
import { DataNotificationPush } from '../../data/DataNotificationPush';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
******************************************************************************************************
PROPS :
    ATTRIBUTS :
        string  description                 description de la notification push
        int?    idNotificationPush          id de la notification push
        bool    isOpen                      détermine si panel ouvert ou non
        string  nomNotificationPush         nom de la notification push

    METHODES :
        void    onDismiss                   méthode appelée lorsque l'utilisateur clique sur "Annuler"
        void    onMiseAJour                 méthode appelée lorsque l'utilisateur clique sur "Valider" ou "Supprimer"
******************************************************************************************************
*/

export class FicheNotificationPush extends Component {

    static defaultProps = {
        nomNotificationPush: "",
        description: "",
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idNotificationPush;
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de la notification push en cours..."
        });

        const { idNotificationPush } = this.props;
        const { nomNotificationPush, description } = this.state;
        const notificationPush = { idNotificationPush, nomNotificationPush, description };

        DataNotificationPush._onEnregistrementNotificationPush(notificationPush)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this.props.onMiseAJour();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });

    };

    _onOpen = () => {
        const { nomNotificationPush, description } = this.props;
        this.setState(
            {
                nomNotificationPush, description,
                hideMessageBarError: true,
                hideMessageBarWarning: true,
                onActiveBoutonEnregistrer: false
            },
            this._onVerificationFormulaire
        );
    };

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._enregistrer} disabled={!onActiveBoutonEnregistrer}>Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onVerificationFormulaire = () => {
        const { nomNotificationPush, description } = this.state;
        const notificationPush = { nomNotificationPush, description };
        Immocom.fiche()._validationFormulaire(this, "NotificationPush", notificationPush, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { nomNotificationPush, description } = this.state;
        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();

        return <Fragment>

            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={`${this._estFicheOuverteEnModeCreation() ? "Création" : "Modification"} d'une notification push`}
                isOpen={isOpen}
                onDismiss={onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.smallFixedFar}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack>

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        infoMessage={this.state.messageMessageBarFiltres}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    <EUITextField
                        disabled={!estFicheOuverteEnModeCreation}
                        label="Nom"
                        maxLength={MaxLengths.notificationPush.nomNotificationPush}
                        onDelayedChange={(event, newValue) => this.setState({ nomNotificationPush: newValue }, this._onVerificationFormulaire)}
                        placeholder="Nom"
                        required
                        value={nomNotificationPush}
                    />

                    <EUITextField
                        label="Description"
                        maxLength={MaxLengths.notificationPush.description}
                        multiline
                        onChonDelayedChangeange={(event, newValue) => this.setState({ description: newValue }, this._onVerificationFormulaire)}
                        placeholder="Description"
                        required
                        rows={3}
                        value={description}
                    />

                </Stack>

            </Panel>

        </Fragment>;

    };

};